<script>

  import moduleUtils from 'src/app/module/ModuleUtils';
  import {mapActions} from 'vuex';

  import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
  import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';

  export default{
    props: ["attr", "fieldValue", "formIdentifier", "instance", "label"],
    data(){
        return {
          notificationError: null,
          notificationSuccess: null
        }
    },
    components: {
      SgsRenderNotificationSuccess,
      SgsRenderNotificationError
    },
    methods: {
      ...mapActions([
        'showLoader',
        'hideLoader'
      ]),
      callBusinessRule: function() {
        if (this.attr.eventOnClick) {
          this.$emit('callBusinessRule', this.attr.eventOnClick);
        }
      },
      returnNewFormIdentifier: function(formId) {
        let formIdentifier = Object.assign({}, this.formIdentifier);
        formIdentifier.formId = formId;

        return formIdentifier;
      },
      generateReport: function () {

        this.showLoader();

        moduleUtils.moduleFormGenerateReport(this.returnNewFormIdentifier(this.attr.formId), this.instance, true)
          .then(response => {

            this.hideLoader();

            if (response.body) {
              this.notificationError = response.body.notificationError;
              this.notificationSuccess = response.body.notificationSuccess;
            }

            if (response.meta.code == 400) {

              _.forOwn(response.body.instance, (value, key) => {
                this.$set(this.instance, key, value);
              });

            } else if (response.meta.code == 500) {

              this.$notify({
                title: 'Error',
                message: this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
                type: 'error'
              });
            }
          });
      }
    },
    computed: {
      alingButton: function () {
        if (this.attr.alingButton) {
          return "marginTop25px"
        }
        return ""
      }
    }
  }

</script>

<template>
  <div>
    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <el-button
      :class="alingButton"
      size="small"
      type="primary"
      @click.prevent="generateReport()"
      :disabled="attr.disableField"
    >
      {{label}}
    </el-button>
  </div>
</template>

<style scoped>
  .marginTop25px {
    margin-top: 25px;
  }
  .el-button {
    margin-bottom: 22px !important;
  }
</style>



// WEBPACK FOOTER //
// SgsRenderButtonReport.vue?33dab951